import { useState } from 'react'

/** Stays true after a live stream so late cards can still enter once. */
export function useLiveStreamEnter(streaming) {
  const [live, setLive] = useState(Boolean(streaming))
  if (streaming && !live) setLive(true)
  return live || Boolean(streaming)
}
